import { useLinkedEntitiesContext } from '../../LinkedEntitiesProvider';

const useGetCellEntities = sourceEntityId => {
  const {
    linkedEntitiesMap,
    isLoadingRelationships,
    error,
    isLoadingEntities
  } = useLinkedEntitiesContext();

  const entities = linkedEntitiesMap[sourceEntityId] || [];

  return {
    entities,
    isLoading: isLoadingRelationships || isLoadingEntities,
    error
  };
};

export default useGetCellEntities;
